"use strict";
import Account from "../../api/account";
export function auditBillingEnabledFor(carrierInvoice, load) {
  var _a, _b;
  if (!Account.auditBillingEnabled()) {
    return false;
  }
  return (_b = (_a = carrierInvoice == null ? void 0 : carrierInvoice.audit_billing_enabled) != null ? _a : load == null ? void 0 : load.audit_billing_enabled) != null ? _b : true;
}
